<template>
    <v-stepper v-model="e1" class="password-stepper create-account-stepper">
        <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1" color="greenMain">
                Account Info
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="2" color="#708AA7"> Password </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
            <v-stepper-content step="1">
                <v-card class="deposit-form create-account-form"
                    :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
                    <v-row dense>
                        <v-col cols="12" sm="12" md="12">
                            <fieldset>
                                <legend>Account Type</legend>
                                <v-select ref="accountTypeSelect" v-model="selectedAccountId" solo
                                    :items="formatedAccountTypes" item-value="id" item-text="account_type_display"
                                    append-icon="mdi-chevron-down" label="Select Account Type" @change="handleAccount"
                                    class="custom-select" single-line hide-details="auto">
                                </v-select>
                            </fieldset>
                            <span v-if="error.accountTypesError" class="error-message">
                                {{ error.accountTypesError }}
                            </span>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <fieldset>
                                <legend>Leverage</legend>
                                <v-select ref="leverageSelect" v-model="selectedLeverage" solo
                                    :items="formatedLeverages" item-value="leverage" item-text="displayText"
                                    append-icon="mdi-chevron-down" label="Select Leverage" class="custom-select"
                                    @change="handleLeverage" hide-details="auto">
                                </v-select>
                            </fieldset>
                            <span v-if="error.leverageError" class="error-message">
                                {{ error.leverageError }}
                            </span>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <fieldset>
                                <legend>Currency <span :style="{ color: this.currency_color }" >{{ this.currency_symbol }}</span></legend>
                                <v-text-field :label="this.currency" single-line solo hide-details class="custom-select" disabled>
                                </v-text-field>
                            </fieldset>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                            <v-btn class="text-capitalize btn-account" color="greenMain" tile elevation="0"
                                @click="handleNext">
                                Next Step
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-stepper-content>

            <v-stepper-content step="2">
                <v-card class="deposit-form password-field create-account-form"
                    :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
                    <v-row>
                        <v-col>
                            <fieldset>
                                <legend>Password</legend>
                                <v-text-field label="**************" v-model="password"
                                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'"
                                    counter @click:append="show1 = !show1" single-line solo hide-details
                                    class="custom-select"></v-text-field>
                            </fieldset>
                            <div class="tick-mark justify-start">
                                <span>
                                    <v-icon small :class="hasMinimumLength ? 'text--green' : 'text--primary'">
                                        mdi mdi-check
                                    </v-icon>
                                    8 Characters
                                </span>
                                <span>
                                    <v-icon small :class="hasLowerCase ? 'text--green' : 'text--primary'">
                                        mdi mdi-check
                                    </v-icon>
                                    1 Lowercase
                                </span>
                                <span>
                                    <v-icon small :class="hasUpperCase ? 'text--green' : 'text--primary'">
                                        mdi mdi-check
                                    </v-icon>
                                    1 Uppercase
                                </span>
                                <span>
                                    <v-icon small :class="hasDigit ? 'text--green' : 'text--primary'">
                                        mdi mdi-check
                                    </v-icon>
                                    1 Digit
                                </span>
                                <span>
                                    <v-icon small :class="hasSpecialCharacter ? 'text--green' : 'text--primary'">
                                        mdi mdi-check
                                    </v-icon>
                                    1 Special Character
                                </span>
                            </div>
                            <fieldset>
                                <legend>Confirm Password</legend>
                                <v-text-field v-model="password2" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                                    :type="show2 ? 'text' : 'password'" counter @click:append="show2 = !show2"
                                    label="Write Password Again" single-line solo hide-details
                                    class="custom-select"></v-text-field>
                            </fieldset>
                            <span v-if="error.passwordError" class="error-message">
                                {{ error.passwordError }}
                            </span>
                            <v-card-actions class="pa-0">
                                <v-col cols="12" sm="6" md="6">
                                    <v-btn class="text-capitalize btn-account" color="greenMain" tile elevation="0"
                                        @click.prevent="handlePrevious">
                                        Previous Step
                                    </v-btn>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-btn class="text-capitalize btn-account" color="greenMain" tile elevation="0"
                                        :disabled="!allConditionsMet || loading" :loading="loading" @click.prevent="handleSubmit">
                                        Create Account
                                    </v-btn>
                                </v-col>
                            </v-card-actions>
                        </v-col>
                    </v-row>
                </v-card>
            </v-stepper-content>
        </v-stepper-items>
    </v-stepper>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TRADING__ACTIONS } from "@/store/action-types";

export default {
    data() {
        return {
            loading: false,
            selectedAccountId: null,
            selectedLeverage: null,
            password: "",
            password2: "",
            show1: false,
            show2: false,
            e1: 1,
            error: {
                accountTypesError: null,
                leverageError: null,
                passwordError: null,
            },
            hasMinimumLength: false,
            hasLowerCase: false,
            hasUpperCase: false,
            hasDigit: false,
            hasSpecialCharacter: false,
            currency: "USD",
            currency_color: "#fff",
            currency_symbol: "$",
        };
    },
    computed: {
        ...mapState("trading", ["accountTypes", "leverages", "leverage_account_type"]),

        formatedLeverages() {
            if (this.leverage_account_type?.length > 0) {
                return this.leverage_account_type.map((item) => {
                    const { id, leverage } = item;
                    const displayText = `1:${leverage}`;
                    return { id, displayText, leverage };
                });
            } else {
                return [];
            }
        },

        formatedAccountTypes() {
            return this.accountTypes.map((item) => {
                const { id, account_type_display } = item;
                return { id, account_type_display };
            });
        },

        allConditionsMet() {
            return (
                this.hasMinimumLength &&
                this.hasLowerCase &&
                this.hasUpperCase &&
                this.hasDigit &&
                this.hasSpecialCharacter &&
                this.password &&
                this.password2 &&
                this.password === this.password2
            );
        },
    },
    watch: {
        password: function () {
            this.hasMinimumLength = this.password.length >= 8;
            this.hasLowerCase = /.*[a-z].*/.test(this.password);
            this.hasUpperCase = /.*[A-Z].*/.test(this.password);
            this.hasDigit = /.*\d.*/.test(this.password);
            this.hasSpecialCharacter = /.*[@$!%*#?&^_-].*/.test(this.password);
        },
    },
    methods: {
        ...mapActions("trading", [
            TRADING__ACTIONS.ACCOUNTTYPES,
            TRADING__ACTIONS.LEVERAGES,
            TRADING__ACTIONS.OPENTRADINGACCOUNT,
            TRADING__ACTIONS.LEVERAGEACCOUNTTYPE
        ]),

        handleAccount(selectedAccount) {
            let account_type = this.accountTypes.find(acc => acc.id === selectedAccount);
            if(account_type){
                this.currency = account_type.currencies?.currency_name;
                this.currency_symbol = account_type.currencies?.symbol;
                this.currency_color = account_type.currencies?.symbol_color;
            }
            this.selectedAccountId = selectedAccount;
            this[TRADING__ACTIONS.LEVERAGEACCOUNTTYPE](selectedAccount)
        },

        handleLeverage(selectedLeverage) {
            this.selectedLeverage = selectedLeverage;
        },

        handleNext() {
            if (!this.selectedAccountId) {
                this.error.accountTypesError = "Select at least one account type";
            }

            if (!this.selectedLeverage) {
                this.error.leverageError = "Select at least one leverage";
            }

            if (this.selectedAccountId && this.selectedLeverage) {
                this.e1 = 2;
            }
        },

        handlePrevious() {
            this.e1 = 1;
        },

        async handleSubmit() {

            if (this.password !== this.password2) {
                this.error.passwordError = "Password did not match";
                return;
            }

            if (!this.selectedAccountId) {
                this.error.accountTypesError = "Please select an account type";
            }
            if (!this.selectedLeverage) {
                this.error.leverageError = "Please select leverage";
            }
            if (!this.password || !this.password2) {
                this.error.passwordError = "Password is required";
            }

            if (Object.values(this.error).some((err) => err !== null)) {
                return;
            }

            this.loading = true;

            try {
                const data = {
                    trading_account_type_id: this.selectedAccountId,
                    leverage: this.selectedLeverage,
                    password: this.password,
                };

                const response = await this[TRADING__ACTIONS.OPENTRADINGACCOUNT](data);

                if (response.success) {
                    this.selectedAccountId = null;
                    this.selectedLeverage = null;
                    this.password = "";
                    this.password2 = "";

                    if (this.$refs.accountTypeSelect) {
                        this.$refs.accountTypeSelect.reset();
                        this.$refs.accountTypeSelect.internalValue = null;
                    }

                    if (this.$refs.leverageSelect) {
                        this.$refs.leverageSelect.reset();
                        this.$refs.leverageSelect.internalValue = null;
                    }

                    this.show1 = false;
                    this.show2 = false;
                    this.e1 = 1;

                    this.error = {
                        accountTypesError: null,
                        leverageError: null,
                        passwordError: null,
                    };

                    this.hasMinimumLength = false;
                    this.hasLowerCase = false;
                    this.hasUpperCase = false;
                    this.hasDigit = false;
                    this.hasSpecialCharacter = false;

                    this.$nextTick(() => {
                        this.$refs.accountTypeSelect?.$forceUpdate();
                        this.$refs.leverageSelect?.$forceUpdate();
                    });
                }
            } catch (error) {
                console.error("Manager account creation error:", error);
                this.error.passwordError = "An error occurred. Please try again.";
            } finally {
                this.loading = false;
            }
        }

    },
    async mounted() {
        await this[TRADING__ACTIONS.ACCOUNTTYPES]();
        await this[TRADING__ACTIONS.LEVERAGES]();
    },
};
</script>
